
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/home/logged-in",
      function () {
        return require("private-next-pages/[locale]/home/logged-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/home/logged-in"])
      });
    }
  